let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kdMbL")).then(() => parcelRequire('2194i'));